module.exports = __webpack_public_path__ + "img/tv-bird.d7329b0e.png";